import React from "react"

export default () => {
  return <div className="footer">
    <div>
      Copyright © 2022 <strong>PUDO Admin Panel</strong> All rights reserved.
    </div>
  </div>
}